'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../../i-bem/i-bem.react');

exports.default = (0, _iBem.decl)({
    block: 'textarea',
    elem: 'control',
    tag: 'textarea',
    attrs: function attrs(ctx) {
        return ctx;
    }
});